import { render, staticRenderFns } from "./wiki_notes_app.vue.js?vue&type=template&id=0a9d5846&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_app.vue?vue&type=template&id=0a9d5846&vue3"
import script from "./wiki_notes_app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_app.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_notes_app.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_app.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports